import { Box, Skeleton, Text } from '@timelyapp/react';
import classNames from 'classnames';
import React from 'react';
import styles from './GeneratedNotePreview.module.scss';

interface Props {
  title: string;
  icon: React.ReactNode;
  note?: string;
  expectedLength?: 'short' | 'long';
  onSelect: () => void;
}

export const GeneratedNotePreview: React.FC<Props> = ({
  title,
  icon,
  note,
  onSelect,
  expectedLength = 'short',
}) => {
  return (
    <Box.Column gap="large">
      <Box.Row gap="medium">
        {icon}
        <Text.Label size="small">{title}</Text.Label>
      </Box.Row>

      {note ? (
        <div
          className={classNames(styles.noteContainer, styles.commonContainer)}
          onClick={onSelect}
        >
          {note}
        </div>
      ) : (
        <div className={classNames(styles.noteContainer, styles.loading)}>
          <Skeleton.Text
            type="paragraph"
            size="xsmall"
            lines={expectedLength === 'short' ? 2 : 3}
            truncateLastLine
            className={styles.skeletonText}
          />
        </div>
      )}
    </Box.Column>
  );
};
